import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';
import type {
  EvidenceLedger,
  ReconciliationState,
  WorkerAttempts,
} from '../types/operator';

/**
 * WI-14: read-only operator-console hooks over the MCP server's read endpoints.
 * These only GET projected execution/authority state — evidence ledger,
 * reconciliation state, and worker-attempt fencing. The console never mutates
 * here; actionable controls hand off to the native app via typed deep links.
 */

export function useInstanceEvidence(id: string | undefined) {
  return useQuery<EvidenceLedger>({
    queryKey: ['instances', id, 'evidence'],
    queryFn: async () => {
      const res = await api.get(`/api/instances/${id}/evidence`);
      return res.data;
    },
    enabled: !!id,
    refetchInterval: 15000,
  });
}

export function useInstanceReconciliation(id: string | undefined) {
  return useQuery<ReconciliationState>({
    queryKey: ['instances', id, 'reconciliation'],
    queryFn: async () => {
      const res = await api.get(`/api/instances/${id}/reconciliation`);
      return res.data;
    },
    enabled: !!id,
    refetchInterval: 10000,
  });
}

export function useRunnerAttempts(id: string | undefined) {
  return useQuery<WorkerAttempts>({
    queryKey: ['runners', id, 'attempts'],
    queryFn: async () => {
      const res = await api.get(`/api/runners/${id}/attempts`);
      return res.data;
    },
    enabled: !!id,
    refetchInterval: 10000,
  });
}
